export default __webpack_public_path__ + "static/logo-white-cc64e65c6b07315d46d7fbc8fae42cac.webp";